// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2TahH","label":"LabeledBox_label__22NXl"};